// Funções utilitárias para autenticação

export function getToken() {
  return sessionStorage.getItem('token');
}

export function getUsuario() {
  const u = sessionStorage.getItem('usuario');
  return u ? JSON.parse(u) : null;
}

export function logout() {
  sessionStorage.removeItem('token');
  sessionStorage.removeItem('usuario');
  window.location.href = '/login';
}
